/**
 * AppLayout - Layout wrapper that renders TopNav on desktop and BottomNav on mobile.
 *
 * Provides proper padding for fixed navigation elements and renders
 * the main content area. Uses useAuth() to check if user is admin.
 *
 * Requirements: 22.1, 22.2, 22.5
 */

import type { ReactNode } from 'react';
import { BottomNav } from './BottomNav';
import { TopNav } from './TopNav';

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Desktop top navigation */}
      <TopNav />

      {/* Main content area with padding for fixed nav */}
      <main className="mx-auto max-w-7xl px-4 pt-4 pb-20 md:pt-20 md:pb-4 sm:px-6 lg:px-8">
        {children}
      </main>

      {/* Mobile bottom navigation */}
      <BottomNav />
    </div>
  );
}
